import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewAramSelected = (props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0429 0L0 15.0427V18.0002H2.95725L18 2.95744V0H15.0429Z" fill="#F4C874" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6685 1.125L1.125 11.6685V9.41773L9.41792 1.125H11.6685Z"
      fill="#9A7D46"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.8743 6.33264L16.875 8.58246L8.58227 16.8752L6.33264 16.8743L16.8743 6.33264Z"
      fill="#9A7D46"
    />
  </svg>
);
